
import {defineComponent, PropType} from 'vue'
import ItemIcons from "@/components/layouts/pim/PimProductsOverviewItemIcons.vue";
import {ProductCategorizationRestService} from "@/services/rest/cpc-product-mgmt/ProductSortWeightRestService";
import {AbilityContext} from "@/context/AbilityContext";
import {Tooltip} from "bootstrap";
import {StandardPriceSourceEnum} from "@/api/enums/standard-price-source-enum";
import {
  CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

export default defineComponent({
  name: "CatalogProductsOverviewTableItem",
  components: {ItemIcons},
  emits: ['dataChanged'],
  props: {
    product: {
      type: Object as PropType<CatalogProductWithImageOverviewRestDtoModel>,
      required: true
    },
    onlyProductsWithCustomWeights: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      new Tooltip(el as Element);
    });
  },
  computed: {
    AbilityContext() {
      return AbilityContext
    },
    productPrice(): number | null{
      if (this.product.product.product_price.standard_price_source_code === StandardPriceSourceEnum.NO_PRICE_AVAILABLE) {
        return null;
      }
      return this.product.product.product_price.sale_price_with_vat;
    },
    priceClass(): string | null {
      if (!this.product.product.product_price.standard_price_source_code) {
        return null;
      }
      if ([
        StandardPriceSourceEnum.DP_REFERENCE,
        StandardPriceSourceEnum.DP_REFERENCE_MODIFIED
      ].includes(this.product.product.product_price.standard_price_source_code)) {
        return 'dashed-underline fst-italic';
      }
      return null;
    },
    tooltip(): string | null {
      if (!this.product.product.product_price.standard_price_source_code) {
        return null;
      }
      if (this.product.product.product_price.standard_price_source_code === StandardPriceSourceEnum.NO_PRICE_AVAILABLE) {
        return this.$t('noPriceAvailable');
      }
      if ([
        StandardPriceSourceEnum.DP_REFERENCE,
        StandardPriceSourceEnum.DP_REFERENCE_MODIFIED
      ].includes(this.product.product.product_price.standard_price_source_code)) {
        return this.$t('thisIsAReferencePrice');
      }
      return null;
    },
  },
  methods: {
    openProductDetail(): void {
      this.$router.push({name: 'catalog-products-detail', params: {product_code: this.product.product.product_code}});
    },
    async addSortWeight(): Promise<void> {
      await ProductCategorizationRestService.getInstance().createCustomerProductSortWeight(this.product.product.product_code);
      this.$emit('dataChanged');
    },
    async deleteSortWeight(): Promise<void> {
      await ProductCategorizationRestService.getInstance().deleteCustomerProductSortWeight(this.product.product.product_code);
      this.$emit('dataChanged');
    },
    async moveToTop(): Promise<void> {
      await ProductCategorizationRestService.getInstance().moveCustomerProductSortWeightToTop(this.product.product.product_code);
      this.$emit('dataChanged');
    },
    async moveToBottom(): Promise<void> {
      await ProductCategorizationRestService.getInstance().moveCustomerProductSortWeightToBottom(this.product.product.product_code);
      this.$emit('dataChanged');
    },
  }
})
